import { useCallback } from 'react';
import { useSessionStore } from '../../../state/src/useSessionStore';
import type { SessionState } from '../../../state/src/useSessionStore';

export const useApiWithLoading = () => {
  const startLoading = useSessionStore((s: SessionState) => s.startLoading);
  const stopLoading = useSessionStore((s: SessionState) => s.stopLoading);

  const executeWithLoading = useCallback(async <T>(
    apiCall: () => Promise<T>,
    loadingMessage: string = 'Loading...'
  ): Promise<T> => {
    console.log('executeWithLoading====>',loadingMessage);
    try {
      startLoading(loadingMessage);
      const result = await apiCall();
      return result;
    } catch (error) {
      // Re-throw the error so it can be handled by the calling component
      throw error;
    } finally {
      stopLoading();
    }
  }, [startLoading, stopLoading]);

  return { executeWithLoading };
};

export default useApiWithLoading;
